const visibleTypes = {
    WORD_GROUP: "WORD_GROUP",
    PARAGRAPH: "PARAGRAPH",
    MULTIPLE_CHOICE: "MULTIPLE_CHOICE"
}

export default visibleTypes